import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { StoreApplicant } from '@funnels/types';

const isPartnerInApplicants = (applicants: StoreApplicant[], partnerId: string) =>
  applicants.some((applicant) => get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_ID(0)) === partnerId);

export default function getMarriedApplicantIds(applicants: StoreApplicant[]): string[] {
  return applicants.reduce((acc: string[], applicant: StoreApplicant) => {
    const applicantId = applicant.id;
    if (!applicantId || acc.includes(applicantId)) {
      return acc;
    }

    const maritalStatus = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_MARITAL_STATUS(0));
    const partnerId = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS_APPLICANT_ID(0));
    // check if the partner id is still in applicants list
    if (!isPartnerInApplicants(applicants, partnerId)) {
      return acc;
    }
    const hasMaritalRelation =
      (maritalStatus === FIELD_VALUES.MARRIED || maritalStatus === FIELD_VALUES.DE_FACTO) && partnerId;

    if (!hasMaritalRelation) {
      return acc;
    }

    const applicantType = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_TYPE(0));
    const partnerApplicant = applicants.find((applicant: StoreApplicant) => applicant.id === partnerId);
    const partnerApplicantType = get({ applicants: [partnerApplicant] }, FIELD_PATHS.APPLICANT_TYPE(0));

    // due to permissions we can only group up Borrower-Borrower and Guarantor-Guarantor but never Borrower-Guarantor
    if (partnerApplicantType !== applicantType) {
      return [...acc, applicantId, partnerId];
    }

    return acc;
  }, []);
}
